import { Typography } from 'hephaestus/web';

export const SortIndicator = ({
  sorted,
}: {
  sorted: false | 'asc' | 'desc';
}) =>
  sorted ? (
    <Typography
      variant='labelSmall'
      component='span'
      sx={{
        ml: 0.25,
        verticalAlign: 'middle',
        fontSize: '8px',
        color: 'text.secondary',
      }}
    >
      {sorted === 'asc' ? '▲' : '▼'}
    </Typography>
  ) : null;
